import {Input} from 'antd';

import {Form} from '../../../../../../../typings/antd';
import {AttributePropsType, TextSingleAttributeType} from '../attributes-type';

export function TextAttribute({value, onChange}: AttributePropsType<TextSingleAttributeType>): JSX.Element | null {
    const {displayName: label, values} = value;

    const firstAndOnlyValue = values[0];

    const {status} = Form.Item.useStatus();

    if (!firstAndOnlyValue) {
        return null;
    }

    return (
        <Form.Item label={label}>
            <Input
                onChange={(event) =>
                    onChange?.({...value, values: [{...firstAndOnlyValue, value: event.target.value}]})
                }
                status={status === 'error' ? status : undefined} // eslint-disable-line no-undefined
                value={values.find((item) => item.value)?.value}
            />
        </Form.Item>
    );
}
